import { render, staticRenderFns } from "./goodsSelfStatitics.vue?vue&type=template&id=49aff18f&scoped=true"
import script from "./goodsSelfStatitics.vue?vue&type=script&lang=js"
export * from "./goodsSelfStatitics.vue?vue&type=script&lang=js"
import style0 from "./goodsSelfStatitics.vue?vue&type=style&index=0&id=49aff18f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49aff18f",
  null
  
)

export default component.exports